import { render, staticRenderFns } from "./HomeFeedFilters.vue?vue&type=template&id=22f8a4f0&"
import script from "./HomeFeedFilters.vue?vue&type=script&lang=ts&"
export * from "./HomeFeedFilters.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports